// In-app activity center (notifications). Web has no APNs registration — the
// bell + feed read the same /notifications surface as iOS.
import { api } from "./client";

export interface NotificationItem {
  id: string;
  kind: string;
  title: string;
  body: string;
  actor_display_name: string | null;
  actor_avatar_url: string | null;
  clan_id: string | null;
  clan_name: string | null;
  created_at: string;
  unread: boolean;
}

export interface NotificationsResponse {
  items: NotificationItem[];
  unread_count: number;
}

export function listNotifications(): Promise<NotificationsResponse> {
  return api.get<NotificationsResponse>("/notifications");
}

export function notificationsUnreadCount(): Promise<{ count: number }> {
  return api.get<{ count: number }>("/notifications/unread-count");
}

export function markNotificationsRead(): Promise<{ count: number }> {
  return api.post<{ count: number }>("/notifications/read", {});
}
